import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { academyGet } from './academyApi';

export default function AcademyWorkspaceEntry({ manage = false }) {
  const [meta, setMeta] = useState(null);
  useEffect(() => {
    const controller = new AbortController();
    Promise.resolve(academyGet('/courses/workspace/meta', controller.signal)).then(result => {
      if (!controller.signal.aborted) setMeta(result?.response || null);
    }).catch(() => {});
    return () => controller.abort();
  }, []);
  if (!meta) return null;
  if (manage) return (meta.canInitialize || meta.owner) ? <p><Link to="/sales-academy?workspace=access">{meta.owner ? 'Manage private pilot' : 'Set up private pilot'} →</Link></p> : null;
  return meta.allowed ? <><Link className="academy-tool" to="/sales-academy?workspace=paths"><strong>Training &amp; tools</strong><span>Learning paths, marketing tools and your daily plan →</span></Link><Link className="academy-tool" to="/training-resources?section=property"><strong>Resources</strong><span>Flood zones, TDHCA forms and Texas permits →</span></Link></> : null;
}
